import React, { useState } from 'react';
import { Toaster, toast } from 'react-hot-toast';

import { images } from '../../constants';
import { AppWrapp, MotionWrapp } from '../../wrapper';
import { client } from '../../Client';
import './Footer.scss';

const Footer = () => {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const { username, email, message } = formData;

  const handleChangeInput = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const validateEmail = (email) => {
    return email.match(
      /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
    );
  };

  const handleSubmit = () => {

    if (username === '' || email === '' || message === '') {
      setLoading(false);
      toast.error("All Fields are required and cannot be blank");
    } else if (!validateEmail(email)) {
      toast.error("Please Enter a Valid Email");
    }
    else {
      try {
        setLoading(true);
        setIsFormSubmitted(true);
        setLoading(false);
      }
      catch (err) {
        console.log(err)
      };
    }
    // const contact = {
    //   _type: 'contact',
    //   name: formData.username,
    //   email: formData.email,
    //   message: formData.message,
    // };

    // client.create(contact)
    //   .then(() => {
    //     setLoading(false);
    //     setIsFormSubmitted(true);
    //   })
    //   .catch((err) => console.log(err));
  };

  return (
    <>
      <div><Toaster
        position="top-right"
        reverseOrder={true}
      /></div>
      <h2 className="head-text">chat with me</h2>

      <div className="app__footer-cards">
        <div className="app__footer-card ">
          <img src={images.email} alt="email" />
          <a href="mailto:soumyadexter7@gmail.com" className="p-text">soumyadexter7@gmail.com</a>
        </div>
        <div className="app__footer-card">
          <img src={images.mobile} alt="phone" />
          <a href="tel:+91 (891) 091-2281" className="p-text">+91 8910912281</a>
        </div>
      </div>
      {!isFormSubmitted ? (
        <div className="app__footer-form app__flex">
          <div className="app__flex">
            <input className="p-text" type="text" placeholder="Your Name" name="username" value={username} onChange={handleChangeInput} />
          </div>
          <div className="app__flex">
            <input className="p-text" type="email" placeholder="Your Email" name="email" value={email} onChange={handleChangeInput} />
          </div>
          <div>
            <textarea
              className="p-text"
              placeholder="Your Message"
              value={message}
              name="message"
              onChange={handleChangeInput}
            />
          </div>
          <button type="button" className="p-text" onClick={handleSubmit}>{!loading ? 'Send Message' : 'Sending...'}</button>
        </div>
      ) : (
        <div>
          <h3 className="head-text">
            Thank you For Getting in Touch!
          </h3>
        </div>
      )}
    </>
  );
};

export default AppWrapp(
  MotionWrapp(Footer, 'app__footer'),
  'contact',
  'app__whitebg',
);

